import React, { useEffect, useState } from "react";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { TurfTalk } from "@/api/client";

/**
 * Honest, always-visible statement of which backend the browser is talking to.
 * Never claims shared/production data unless the BFF live-check proves it is
 * actually proxying to the canonical Turf Talk backend.
 */
export function ConnectionBanner() {
  const [meta, setMeta] = useState(null);
  useEffect(() => { TurfTalk.canonicalMeta().then(setMeta).catch(() => {}); }, []);
  if (!meta) return null;

  if (meta.connected_to_canonical) {
    return (
      <div className="w-full bg-[#12331c] border-b border-[#1e5a2e] text-[#7ee08a]" data-testid="canonical-banner">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2 flex items-center gap-2 text-[12px]">
          <CheckCircle2 size={14} className="shrink-0" />
          <span>Connected to the <strong>canonical Turf Talk backend</strong> — accounts, rooms, messages and picks are shared with mobile ({meta.canonical_api_url}).</span>
        </div>
      </div>
    );
  }

  const unreachable = meta.mode === "canonical_unreachable";
  return (
    <div className="w-full bg-[#3a2f12] border-b border-[#5a4a1e] text-[#F4B740]" data-testid="canonical-banner">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-2 flex items-center gap-2 text-[12px] leading-snug">
        <AlertTriangle size={14} className="shrink-0" />
        {unreachable ? (
          <span>
            <strong className="text-[#f7d488]">Canonical backend unreachable</strong> — tried <code className="px-1 rounded bg-black/30">{meta.canonical_api_url}</code> but its <code className="px-1 rounded bg-black/30">/api/v1</code> health check failed ({meta.live_check}). Serving the local preview instance; <strong>accounts and records here are preview-only, not shared with mobile</strong>.
          </span>
        ) : (
          <span>
            <strong className="text-[#f7d488]">Preview backend</strong> — running a local instance of the Turf Talk backend code, <strong>not the shared production database</strong>. Set a reachable <code className="px-1 rounded bg-black/30">CANONICAL_API_URL</code> (/api/v1 base) to connect and share data with mobile.
          </span>
        )}
      </div>
    </div>
  );
}
